/** Persistent orange seat so gaps stay visible after a ticket flies off. */
export function EmptySeatGlow({ visible }: { visible: boolean }) {
  if (!visible) return null;
  return (
    <div
      data-name="RAFFLE_EMPTY_SEAT"
      className="pointer-events-none absolute inset-0 rounded-xl"
      style={{
        boxShadow:
          '0 0 22px rgba(255,107,61,0.45), inset 0 0 0 2px rgba(255,107,61,0.75)',
      }}
    />
  );
}
